import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ConfigService } from './config.service';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { featureFlagsDetails } from 'src/assets/featureFlagsDetails';


@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {

  private featureFlagsValue: any = {};
  private featureFlagsDetails: any[] = [];

  constructor(private http: HttpClient,
    private configService:ConfigService
  ) {
    this.initializeFeatureFlags();
  }

  private initializeFeatureFlags(): void { 
    this.setFeatureFlagsDetailsFromLocalJSON();
    this.setFeatureFlagsFromLocalStorage();
    this.getFeatureFlagsFromApi();
  }

   /**
   * Update the feature flags from server for latest status
   */
   public updateFeatureFlags() {
    this.setFeatureFlagsFromLocalStorage();
    this.getFeatureFlagsFromApi();
  }
    /**
   * Gets the status of the feature provided, If not available it will return the default status which is passed.
   * @param featureName 
   * @param defaultStatus 
   * @returns 
   */
    public getFeatureStatus(featureName: string, defaultStatus: boolean): boolean {
      if (this.featureFlagsDetails?.length > 0 && this.featureFlagsValue && featureName && featureName != '') {
        const userDetails = this.configService.getLoginDetails();
        const sellerId = userDetails?.SellerID;
        const featureFlagData = this.featureFlagsDetails.find(f => f.Name === featureName);
        if (featureFlagData) {
          if (featureFlagData.Type === 'boolean') {
            return this.featureFlagsValue[featureFlagData.ID] ?? defaultStatus;
          } else if (featureFlagData.Type === 'array' && sellerId) {
            const arrayValue = this.featureFlagsValue[featureFlagData.ID] as number[];
            if (featureFlagData.Condition === 'in') {
              return arrayValue?.includes(Number(sellerId));
            } else if (featureFlagData.Condition === 'out') {
              return !arrayValue?.includes(Number(sellerId));
            }
          }
        }
      }
      return defaultStatus;
    }
      /**
   * Sets the feature flag details 
   */

  private setFeatureFlagsDetailsFromLocalJSON() {
    this.featureFlagsDetails = featureFlagsDetails;
    // this.fetchFeatureFlagsConfigFromLocalJSON().subscribe((res) => {
    //   if(res) {
    //     this.featureFlagsDetails = res;
    //   }
    // });
  }
    /**
   * Sets the feature flag values by getting from localstorage
   */
    private setFeatureFlagsFromLocalStorage() {
      this.featureFlagsValue = null;
      if(localStorage.getItem('featureFlags')) {
        this.featureFlagsValue = JSON.parse(localStorage.getItem('featureFlags') ?? '');
      }
      // this.mergeFeatureFlagsWithConfig();
    }
      /**
   * This will fetch the latest feature flag from serve and update the localstorage
   */
  private getFeatureFlagsFromApi(): void {
    this.getFeatureFlagsForSeller().subscribe(
      (res: any) => {
        if (res?.Result === 'Success' && res?.ResponseData) {
          localStorage.setItem('featureFlags', (res.ResponseData));
          this.setFeatureFlagsFromLocalStorage();
        } else {
          console.warn('Feature flags response not successful or missing data:', res);
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error fetching feature flags:', err.message || err);
      });
  }
    // Http Calls
    private fetchFeatureFlagsConfigFromLocalJSON(): Observable<any[]> {
      return this.http.get<any[]>(environment.featureFlagsPath).pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error fetching feature flags configuration', error);
          return of([]);
        })
      );
    }
  
    private getFeatureFlagsForSeller() {
      const productionStatus = this.isProduction();
      let url = this.configService.getNoAuthUrl() + "/Seller/GetFeatureFlags?productionStatus=" + productionStatus;
      return this.http.get(url);
    }
  
    private isProduction(): boolean {
      return environment.production; 
    }
}
